import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=344cc458&scoped=true&"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=344cc458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cc458",
  null
  
)

export default component.exports